import { classes, selectors } from './lib';

const activeErrorClass = 'active';

const resetFieldErrors = (field) => {
	field.classList.remove(classes.error);
	field.querySelectorAll(selectors.fieldError).forEach((errorMessage) => {
		errorMessage.classList.remove(activeErrorClass);
	});
};

export const markFieldError = (field, error) => {
	resetFieldValid(field);
	resetFieldErrors(field);

	// Add error class
	field.classList.add(classes.error);

	// Show individual error icon
	field.querySelector(`${selectors.fieldError}--${error}`).classList.add(activeErrorClass);
};

const resetFieldValid = (field) => {
	field.classList.remove(classes.valid);
};

export const markFieldAsValid = (field) => {
	resetFieldErrors(field);
	field.classList.add(classes.valid);
};

export const resetFieldState = (field) => {
	resetFieldErrors(field);
	resetFieldValid(field);
};
